import { render } from "./BuildTheSkillsVideo.vue?vue&type=template&id=70ede531&scoped=true"
import script from "./BuildTheSkillsVideo.vue?vue&type=script&lang=js"
export * from "./BuildTheSkillsVideo.vue?vue&type=script&lang=js"

import "./BuildTheSkillsVideo.vue?vue&type=style&index=0&id=70ede531&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ede531"]])

export default __exports__